import { logUserAction } from "../../helpers/user-tracking";

export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
export const DELETE_FROM_WISHLIST = "DELETE_FROM_WISHLIST";
export const DELETE_ALL_FROM_WISHLIST = "DELETE_ALL_FROM_WISHLIST";

// add to wishlist
export const addToWishlist = (item, addToast) => {
  return dispatch => {
    if (addToast) {
      addToast("Added To Wishlist", {
        appearance: "success",
        autoDismiss: true
      });
    }
    // The stocks/knits view wins over the product's own category label, so the
    // log lands on the stock/knit key instead of the underlying fabric one.
    const viewMode = localStorage.getItem("viewMode");
    const isKnitsMode = localStorage.getItem("isKnitsMode") === "true";
    const pathname =
      typeof window !== "undefined" ? window.location.pathname : "";
    const itemType =
      viewMode === "stocks" || pathname.includes("/stocks")
        ? "stocks"
        : isKnitsMode || pathname.includes("/knits")
          ? "knits"
          : item?.attributes?.category?.data?.attributes?.label ||
            item?.category ||
            item?.categoryName;
    if (item?.id) {
      logUserAction("bookmarked", item.id, itemType);
    }
    dispatch({ type: ADD_TO_WISHLIST, payload: item });
  };
};

// delete from wishlist
export const deleteFromWishlist = (item, addToast) => {
  return dispatch => {
    if (addToast) {
      addToast("Removed From Wishlist", {
        appearance: "error",
        autoDismiss: true
      });
    }
    dispatch({ type: DELETE_FROM_WISHLIST, payload: item });
  };
};

//delete all from wishlist
export const deleteAllFromWishlist = addToast => {
  return dispatch => {
    if (addToast) {
      addToast("Removed All From Wishlist", {
        appearance: "error",
        autoDismiss: true
      });
    }
    dispatch({ type: DELETE_ALL_FROM_WISHLIST });
  };
};
